import { useContext, useEffect, useState } from 'react'
import { authContext } from 'contexts/AuthContext'

const usePermission = () => {
  const { auth } = useContext(authContext)
  const [isFinance, setIsFinance] = useState(false)
  const [isApprover, setIsApprover] = useState(false)

  const checkIsPermission = (data) => {
    setIsApprover(data?.permissions?.includes(11))
    setIsFinance(data?.permissions?.includes(12))
    return
  }

  useEffect(() => {
    checkIsPermission(auth?.data)
  }, [auth])

  return { isFinance, isApprover }
}

export default usePermission
